'use client';

import { c as _c } from "react/compiler-runtime";
import { SEGMENT_TOTAL_SPEND_TOOLTIP } from '@/domains/pages/ai-spend/constants';
import type { SegmentSpendSummary } from '@/domains/pages/ai-spend/utils/map-ai-spend-segments';
import { NebulyPageCard } from '@/domains/pages/shared/nebuly-page-card';
import { getPageTimeRangePhrase } from '@/domains/pages/shared/page-time-range';
import { PAGE_DATA_NUMBER_CLASS, PAGE_KPI_NUMBER_CLASS } from '@/domains/pages/shared/typography';
import type { TimeRangeConfig } from '@/api/generated/model';
import { formatSpend } from '@/utils/format.util';
import { cn } from '@/utils/shad';
type SegmentTotalSpendCardProps = {
  selected: SegmentSpendSummary | null;
  timeRange: TimeRangeConfig | undefined;
  className?: string;
};
export function SegmentTotalSpendCard(t0) {
  const $ = _c(20);
  const {
    selected,
    timeRange,
    className
  } = t0;
  let t1;
  if ($[0] !== timeRange) {
    t1 = getPageTimeRangePhrase(timeRange);
    $[0] = timeRange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const periodLabel = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("min-h-0", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = selected?.cost ?? null;
  let t4;
  if ($[4] !== t3) {
    t4 = formatSpend(t3, {
      precision: "exact"
    });
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = selected?.cost ?? null;
  let t6;
  if ($[6] !== t5) {
    t6 = formatSpend(t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <span className={PAGE_KPI_NUMBER_CLASS} title={t4}>{t6}</span>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("pb-1 text-[14px] leading-none text-muted-foreground", PAGE_DATA_NUMBER_CLASS);
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== periodLabel) {
    t9 = <span className={t8}>{periodLabel}</span>;
    $[12] = periodLabel;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <div className="flex flex-wrap items-end gap-3">{t7}{t9}</div>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t2) {
    t11 = <NebulyPageCard title="Total AI spend" description={SEGMENT_TOTAL_SPEND_TOOLTIP} className={t2} contentClassName="flex flex-col gap-3 !py-3" testId="segment-total-ai-spend-card">{t10}</NebulyPageCard>;
    $[17] = t10;
    $[18] = t2;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}